module.exports = __webpack_public_path__ + "img/35d33c7.jpg";